import { render, staticRenderFns } from "./resetpassword.vue?vue&type=template&id=0daaea90&scoped=true&"
import script from "./resetpassword.vue?vue&type=script&lang=js&"
export * from "./resetpassword.vue?vue&type=script&lang=js&"
import style0 from "./resetpassword.vue?vue&type=style&index=0&id=0daaea90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0daaea90",
  null
  
)

export default component.exports